import { render } from "./DisinfectRoom.vue?vue&type=template&id=4eb5c380"
import script from "./DisinfectRoom.vue?vue&type=script&lang=js"
export * from "./DisinfectRoom.vue?vue&type=script&lang=js"
script.render = render

export default script